var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-dropdown',{attrs:{"no-caret":"","variant":_vm.variant,"toggle-class":_vm.variant === 'link' ? 'p-0' : 'px-1',"disabled":_vm.disabled,"lazy":""},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('Icon',{attrs:{"icon":"three-dots-vertical"}})]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }